import { BooleanInput, Create, CreateContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useNotify, useRedirect, useRefresh, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import ErrorPage403 from 'src/pages/error/403';
import CustomTagInput from 'src/pages/admin/components/CustomTagInput';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TrandingTokenForm from './TrandingTokenForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const CreateMetadata = ({ onClose }: { onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useCreateController({
        resource: Resources.trandingToken,
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.trandingToken.createSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    default:
                        notify(t('module.trandingToken.unknownError'), { type: 'error' });
                        break;
                }
            }
        }
    });


    return (
        <CreateContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t("module.trandingToken.create")}</DialogTitle>
                <DialogContent>
                    <TrandingTokenForm isCreate />
                </DialogContent>
                <DialogActions>
                    <MUIButton variant="outlined" onClick={onClose}>
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="tranding-tokens" action="create">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </CreateContextProvider>
    );
};

export default CreateMetadata;
